// frontend/src/layout/UserLayout.jsx

import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import "../style/user-layout.css";

export default function UserLayout() {
  return (
    <div className="user-layout">
      <Sidebar />
      <div className="user-main">
        <div className="user-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}